import { render, staticRenderFns } from "./TwoView.vue?vue&type=template&id=5474eb7e"
import script from "./TwoView.vue?vue&type=script&lang=js"
export * from "./TwoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports